/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };


  // Load Events
  $(document).ready(UTIL.loadEvents);


  // Transform nav
  $('.menu-item-has-children').each(function(){
    $(this).children('a')
      .attr('data-toggle', 'dropdown')
      .append(' <span class="caret"></span>')
    .next('ul')
      .addClass('dropdown-menu');
  });


  // Set all images for lightbox
  $('.vc_single_image-wrapper').each(function(){
    if($(this).parent('a').length > 0){
      $(this).parent('a').attr('data-lightbox', 'lightbox');
    }
  });


  if($('.main-content p img, .tiled-gallery img').parent('a').length > 0){
    $('.main-content p img, .tiled-gallery img').parent('a').attr('data-lightbox', 'lightbox');
  }

  // Set all content's images responsive
  $('.main-content img').addClass('img-responsive');
  $('.main img').addClass('img-responsive');


  // Put language selector in the main navigation
  $('#menu-primary-navigation, #menu-primary-navigation-allemand-2, #menu-primary-navigation-anglais0').append('<li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children lang-selector"></li>');
  $('#lang_sel_list a').each(function(){
    $(this).text($(this).text().trim().substring(0, 2));
  });
  $('#lang_sel_list a').appendTo('.lang-selector');
  $('#lang_sel_list').remove();


  $('.menu-item-language a').addClass('shiftnav-target');


  if (window.matchMedia("(min-width: 600px)").matches) {
    $('.logo-container img').removeClass('img-responsive');
  }
  if (window.matchMedia("(max-width: 600px)").matches) {
    $('footer .text-2 .textwidget img').addClass('img-responsive');
  }


  $('.cart_item .product-name a').contents().unwrap();


  $('#shiftnav-toggle-main-button i').addClass('fa-lg');

  // Remove links into product list
  $('.products .product-title').unwrap();

  //Change the newsletter form
  $('label[for=mc_mv_EMAIL]').text('Adresse e-mail *');
  $('label[for=mc_mv_FNAME]').text('Prénom *');
  $('label[for=mc_mv_LNAME]').text('Nom *');
  $('#mc_display_rewards').hide();
  $('#mc_signup_submit')
    .addClass('btn btn-danger')
    .removeClass('button')
    .css('background-color', '#8A2529')
    .removeAttr('id');


  $('#submitOrder').click(function(event){
    event.preventDefault();
    if($('#inputLivraison').val() === '0'){
      $('#inputLivraison').next('.with-errors').show();
    }else{
      $('#order').submit();
    }
  });


  $('#inputLivraison').change(function(event){
    $('#inputLivraison').next('.with-errors').hide();
  });


  $('#order').validate({
    ignore: ".ignore"
  });
  $('#submitOrder').click( function() { 
    $(document).scrollTop( $("#topOfTheForm").offset().top );  
    $(".alert-success").hide();
    $("#order").valid();  // test the form for validity
  });

  $("input.numeric").numeric();

})(jQuery); // Fully reference jQuery after this point.
